import { render, staticRenderFns } from "./rolesCreateUpdate.vue?vue&type=template&id=0f4955fd&scoped=true&"
import script from "./rolesCreateUpdate.vue?vue&type=script&lang=js&"
export * from "./rolesCreateUpdate.vue?vue&type=script&lang=js&"
import style0 from "./rolesCreateUpdate.vue?vue&type=style&index=0&id=0f4955fd&prod&lang=scss&scoped=true&"
import style1 from "./rolesCreateUpdate.vue?vue&type=style&index=1&id=0f4955fd&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f4955fd",
  null
  
)

export default component.exports